module.exports = __webpack_public_path__ + "static/media/check.7e4b70c1.svg";